import config from '../config'
import GenericApiService from './generic-api-service'

export default new GenericApiService(config.urls.users, '_id')